export default function initProductsByDomain() {
    // ==========================================================
    // PRODUCTS BY DOMAIN
    // ==========================================================

    const productsByDomainSections = document.querySelectorAll(".products-by-domain");

    productsByDomainSections.forEach((section) => {
        const tabs = section.querySelectorAll(".products-by-domain__tab");

        const panels = section.querySelectorAll(".products-by-domain__panel");

        if (!tabs.length || !panels.length) {
            return;
        }

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                const target = tab.dataset.domain;

                tabs.forEach((item) => {
                    const isActive = item === tab;

                    item.classList.toggle("is-active", isActive);

                    item.setAttribute("aria-selected", isActive ? "true" : "false");
                });

                panels.forEach((panel) => {
                    const isActive = panel.dataset.domainPanel === target;

                    panel.classList.toggle("is-active", isActive);

                    panel.hidden = !isActive;
                });
            });
        });
    });
}